import { IsDevEnv, LocalStorageKeys, React, variantProvider } from '@/app'
import { APIClient } from '@/services'
import { navigate } from 'gatsby'
import { useIsomorphicEffect, useState } from '@codeleap/common'
import { ActivityIndicator, Redirect, View } from '@/components'
import { useReadyTimer } from '@/utils'
import { useLocation } from '@reach/router'

export type AuthenticatedScreenProps = {
  children: React.ReactNode
  redirectOnFailure?: boolean
  redirectPath?: string
  showLoading?: boolean
  autoRedirect?: boolean
}

const READY_TIMEOUT = 10000
const FETCH_COUNT_LIMIT = 4
const FETCH_DELAY = 500
const DEBUG = IsDevEnv && false

export const AuthenticatedScreen = (props?: AuthenticatedScreenProps) => {
  const {
    children,
    redirectOnFailure = false,
    redirectPath = '/learn/',
    autoRedirect = false,
  } = props

  const { isLoggedIn, loginResolved } = APIClient.Session.useAuthState()

  const ready = loginResolved

  if (!ready) {
    return (
      <View style={styles.wrapper}>
        <ActivityIndicator debugName='AuthenticatedScreen:loading' />
      </View>
    )
  }

  if (!isLoggedIn && redirectOnFailure) {
    return <Redirect to={redirectPath} />
  }

  return <>
    {children}
  </>
}

const styles = variantProvider.createComponentStyle(theme => ({
  wrapper: {
    width: '100vw',
    height: '100svh',
    ...theme.presets.absolute,
    ...theme.presets.whole,
    ...theme.presets.center,
    zIndex: 5,
  },
}), true)
